import { useTheme } from "@mui/material";

import { useDynamicThemeAwareVariables } from "@/common/hooks/useDynamicThemeAwareVariables";

export const useThemedBrandingColor = () => {
  const theme = useTheme();

  const { color } = useDynamicThemeAwareVariables(({ mode }) => ({
    color: mode === "light" ? theme.palette.forms.text.quiet : theme.palette.forms.border.moderate,
  }));

  return color;
};
